import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopBar from "./TopBar";
import Sidebar from "./Sidebar";
import Homepage from "../Homepage/Homepage";
import SlapGenerator from "../SlapGenerator/SlapGenerator";
import SendSlapPage from "../SlapGenerator/SendSlapPage";
import Leaderboard from "../Leaderboard/Leaderboard";
import Cummingsoon from "../Cummingsoon/Cummingsoon";
import Howtoplay from "../Howtoplay/Howtoplay";
import GBOFs from "../GBOFs/GBOFs";
import CandyShopPage from "../pages/CandyShopPage";
import WrapperStudioPage from "../pages/WrapperStudioPage";
import VIPLoungePage from "../pages/VIPLoungePage";
import CandyCombinerPage from "../pages/CandyCombinerPage";
import TestTransactionPage from "../pages/TestTransactionPage";
import "./layout.scss";
// DckSlap Design System - Tailwind + shadcn
import "../../styles/globals.css";
import { RadixConnectProvider } from "../../../radix_connect";
import { dAppDefinitionAddress } from "../../../constants";

// Layout content component
const LayoutContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("dashboard");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  let lastToggleTime = 0;
  const toggleSidebar = () => {
    const now = Date.now();
    // Prevent multiple rapid toggles within 300ms
    if (now - lastToggleTime < 300) return;
    lastToggleTime = now;

    setIsSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Only for mobile, desktop sidebar is self-contained
  const handleMobileSidebarToggle = () => {
    toggleSidebar();
  };

  // Set active page based on URL
  useEffect(() => {
    const path = location.pathname;
    if (path === "/dckslap" || path === "/dckslap/homepage") {
      setActivePage("dashboard");
    } else if (path === "/dckslap/slapgenerator") {
      setActivePage("generator");
    } else if (path === "/dckslap/leaderboard") {
      setActivePage("leaderboard");
    } else if (path === "/dckslap/achievements") {
      setActivePage("achievements");
    } else if (path === "/dckslap/secret-machine") {
      setActivePage("secret-machine");
    } else if (path === "/dckslap/sendslap") {
      setActivePage("sendslap");
    } else if (path === "/dckslap/howtoplay") {
      setActivePage("howtoplay");
    } else if (path === "/dckslap/candyshop") {
      setActivePage("candyshop");
    } else if (path === "/dckslap/candywrapper") {
      setActivePage("candywrapper");
    } else if (path === "/dckslap/viplounge") {
      setActivePage("viplounge");
    } else if (path === "/dckslap/candycombiner") {
      setActivePage("candycombiner");
    } else if (path === "/dckslap/test-transaction") {
      setActivePage("test-transaction");
    }
  }, [location.pathname]);

  // Handle navigation
  const handleNavigation = (page) => {
    setActivePage(page);
    switch (page) {
      case "dashboard":
        navigate("/dckslap/homepage");
        break;
      case "generator":
        navigate("/dckslap/slapgenerator");
        break;
      case "sendslap":
        navigate("/dckslap/sendslap");
        break;
      case "leaderboard":
        navigate("/dckslap/leaderboard");
        break;
      case "achievements":
        navigate("/dckslap/achievements");
        break;
      case "secret-machine":
        navigate("/dckslap/secret-machine");
        break;
      case "howtoplay":
        navigate("/dckslap/howtoplay");
        break;
      case "candyshop":
        navigate("/dckslap/candyshop");
        break;
      case "candywrapper":
        navigate("/dckslap/candywrapper");
        break;
      case "viplounge":
        navigate("/dckslap/viplounge");
        break;
      case "candycombiner":
        navigate("/dckslap/candycombiner");
        break;
      case "test-transaction":
        navigate("/dckslap/test-transaction");
        break;
      default:
        navigate("/dckslap/homepage");
    }
  };

  const renderActivePage = () => {
    switch (activePage) {
      case "dashboard":
        return <Homepage />;
      case "generator":
        return <SlapGenerator />;
      case "sendslap":
        return <SendSlapPage />;
      case "leaderboard":
        return <Leaderboard />;
      case "achievements":
        return <GBOFs />;
      case "secret-machine":
        return <Cummingsoon />;
      case "howtoplay":
        return <Howtoplay />;
      case "candyshop":
        return <CandyShopPage />;
      case "candywrapper":
        return <WrapperStudioPage />;
      case "viplounge":
        return <VIPLoungePage />;
      case "candycombiner":
        return <CandyCombinerPage />;
      case "test-transaction":
        return <TestTransactionPage />;
      default:
        return <Homepage />;
    }
  };

  return (
    <div className="app-layout dckslap-theme">
      <Sidebar
        setActivePage={handleNavigation}
        isMobileOpen={isSidebarOpen}
        closeSidebar={closeSidebar}
      />
      <div className="app-main">
        <TopBar toggleSidebar={handleMobileSidebarToggle} />
        {isSidebarOpen && (
          <div className="sidebar-overlay" onClick={closeSidebar}></div>
        )}
        <main className="app-content" data-scroll-root>{renderActivePage()}</main>
      </div>
    </div>
  );
};

// Main Layout component wrapped with Radix provider
const Layout = () => {
  return (
    <RadixConnectProvider dAppDefinitionAddress={dAppDefinitionAddress}>
      <LayoutContent />
    </RadixConnectProvider>
  );
};

export default Layout;
